export default "//static.tradera.net/touchweb/static/output/images/app-store-badge-en.7e1bde26.svg";